import React from 'react';
import draggable from './draggable';
import {
  StyledColorMap,
  Background,
  Pointer,
} from './styledComponents';

const ColorMap = ({
  startUpdates,
  getPercentageValue,
  x,
  y,
  backgroundColor,
}) => (
  <StyledColorMap
    onMouseDown={startUpdates}
    onTouchStart={startUpdates}>
    <Background style={{ backgroundColor }} />
      <Pointer style={{
        left: getPercentageValue(x),
        bottom: getPercentageValue(y)
      }}/>
  </StyledColorMap>
);

export default draggable(ColorMap, 100);



// WEBPACK FOOTER //
// ./src/components/ColorPicker/ColorMap.js